import * as ActionType from '../../constants/actionType';

const initialState = {
  availableProtocols: [],
  favoriteProtocols: [],
  lastOpenedProtocol: null,
  lastOpenedFolder: null,
  lastProtocolCheckpoint: null,
  // temporaryUnsavedProtocol is made to store protocol changes that haven't been saved when autosave is disabled.
  // -
  // When there is a protocol running and user opens runtime view,
  // the current cardState and labwareState is gonna be replaced by the running protocol's state.
  // If user were to open another protocol, make changes to it, and go to runtime,
  // those changes will be gone.
  // -
  // so there needs to be an object to temporarily save those unsaved changes.
  temporaryUnsavedProtocolData: null,
};

export default function protocolState(state = initialState, action = '') {
  switch (action.type) {
    case ActionType.RESET_PROTOCOL_STATE:
      return initialState;
    case ActionType.RESTORE_PROTOCOL_STATE:
      return action.data;
    case ActionType.SET_AVAILABLE_PROTOCOLS: {
      return {
        ...state,
        availableProtocols: action.data,
      };
    }
    case ActionType.SET_LAST_OPENED_PROTOCOL:
      return {
        ...state,
        lastOpenedProtocol: action.data,
      };
    case ActionType.SET_LAST_SAVED_PROTOCOL_STATE:
      return {
        ...state,
        lastProtocolCheckpoint: action.data,
      };
    case ActionType.SET_TEMPORARY_UNSAVED_PROTOCOL_DATA:
      return {
        ...state,
        temporaryUnsavedProtocolData: action.data,
      };
    case ActionType.ProtocolStateActionTypes.SET_FAVORITE_PROTOCOLS: {
      return {
        ...state,
        favoriteProtocols: action.data,
      };
    }
    case ActionType.SET_OPENED_PROTOCOL_EJECT_TO_CADDY:
      return {
        ...state,
        lastOpenedProtocol: {
          ...state.lastOpenedProtocol,
          isEjectToCaddy: action.isEjectToCaddy,
        },
      };
    default:
      return state;
  }
}
